var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSchoolFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_62895)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 24,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 44.7999C37.2786 44.7999 44.8002 37.2783 44.8002 28C44.8002 18.7216 37.2786 11.2 28.0002 11.2C18.7218 11.2 11.2002 18.7216 11.2002 28C11.2002 37.2783 18.7218 44.7999 28.0002 44.7999Z",
    fill: "#3A559F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3228 26.0107L32.9849 28.9374C32.9709 29.0709 32.9083 29.1946 32.809 29.2851C32.7098 29.3755 32.5808 29.4264 32.4465 29.428H29.392L29.3767 38.1048C29.3777 38.2076 29.3383 38.3067 29.2668 38.3807C29.1954 38.4546 29.0977 38.4975 28.9949 38.5H25.9002C25.8488 38.5 25.7979 38.4897 25.7505 38.4695C25.7032 38.4494 25.6604 38.4199 25.6247 38.3828C25.5891 38.3457 25.5613 38.3018 25.543 38.2537C25.5247 38.2056 25.5164 38.1543 25.5184 38.1029V29.428H23.2275C23.1556 29.4273 23.0845 29.4123 23.0183 29.3841C22.9521 29.3559 22.8921 29.3149 22.8418 29.2635C22.7914 29.2121 22.7517 29.1512 22.7248 29.0845C22.698 29.0177 22.6846 28.9463 22.6853 28.8744L22.6739 25.9477C22.6729 25.8755 22.6861 25.8038 22.7128 25.7367C22.7395 25.6696 22.7792 25.6085 22.8295 25.5567C22.8799 25.5049 22.9399 25.4636 23.0062 25.435C23.0726 25.4065 23.1439 25.3913 23.2161 25.3903H25.5184V22.5648C25.5184 19.285 27.4657 17.5 30.3217 17.5H32.6622C32.7346 17.5007 32.8061 17.5158 32.8727 17.5442C32.9392 17.5727 32.9995 17.614 33.05 17.6658C33.1006 17.7175 33.1404 17.7788 33.1672 17.846C33.1941 17.9132 33.2073 17.9851 33.2063 18.0575V20.5202C33.2073 20.5925 33.1941 20.6644 33.1672 20.7316C33.1404 20.7988 33.1006 20.8601 33.05 20.9119C32.9995 20.9637 32.9392 21.005 32.8727 21.0334C32.8061 21.0619 32.7346 21.0769 32.6622 21.0776H31.2266C29.6745 21.0776 29.3729 21.8413 29.3729 22.9447V25.3903H32.7844C32.862 25.3912 32.9385 25.4086 33.0089 25.4413C33.0793 25.4739 33.142 25.5211 33.1928 25.5797C33.2437 25.6383 33.2815 25.707 33.3039 25.7813C33.3263 25.8556 33.3328 25.9338 33.3228 26.0107Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_62895",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_62895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_62895",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchoolFacebook);
export default __webpack_public_path__ + "static/media/icon_school_facebook.3cfe84b091ecefadb5a1be7cd062b2e1.svg";
export { ForwardRef as ReactComponent };